import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { CheckoutStore } from "@modules/checkout/services/checkout/checkout-store.service";

export const checkoutDataGuard: CanActivateFn = (route) => {
  const store = inject(CheckoutStore);
  const router = inject(Router);

  if (!store.data()) {
    return router.createUrlTree([`/checkout/${route.params["id"]}`], {
      queryParams: { ...route.queryParams },
    });
  }

  return true;
};
